<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            id="gestoesDeAtendimentosCAEE.voltarBtn"
            color="primary"
            x-small
            text
            @click="goBack"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Lançamentos CAEE
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="turma">
        <v-card color="primary" class="mb-5" outlined>
          <v-card-title> Turma: {{ turma.descricao }}</v-card-title>
          <v-card-subtitle class="font-weight-medium">
            <div>
              Profissional: <strong>{{ profissional ? profissional.name : "- - -" }}</strong>
            </div>
            <div>Total de alunos: {{ matriculasAtivas.length || "- - -" }}</div>
            <div>
              Tipo de atendimento: <strong>{{ turma.tipo_de_atendimento || "- - -" }}</strong> |
              Tipo de ensino:
              <strong>{{ turma.curso?.descricao || "- - -" }}</strong>
            </div>
          </v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>
    <v-card class="mt-3">
      <template>
        <v-tabs
          id="gestoesDeAtendimentosCAEE.atendimentoTabs"
          v-model="tab_atual"
          background-color="primary"
          dark
        >
          <v-tab
            id="gestoesDeAtendimentosCAEE.atendimentoTab"
            v-for="tab of tabs"
            :key="tabs.indexOf(tab)"
            >{{ tab.descricao }}</v-tab
          >
        </v-tabs>
        <div class="text-right" v-if="$can(['relatorios.listarTurma', 'relatorios.*'])">
          <v-btn
            id="gestoesDeAtendimentosCAEE.gerarRelatorioListaTurmaBtn"
            color="primary"
            class="ml-4 mt-4 mr-4 white--text"
            @click="gerarRelatorio"
          >
            Lista da turma
            <v-icon right dark> mdi-file </v-icon>
          </v-btn>
        </div>
        <v-col class="pt-0">
          <v-data-table
            :headers="table.headers"
            :items="matriculas"
            :loading="carregandoGestoesDeAulas"
            :items-per-page="matriculas.length"
            hide-default-footer
            no-data-text="Não foram encontrados vínculos para você, por favor entre em contato com a secretaria/coordenação para que lhe adicionem acesso às turmas e disciplinas"
            class="elevation-1"
          >
            <template v-slot:body="{ items }">
              <tbody name="scroll-x-transition" is="transition-group" duration="200">
                <tr
                  v-for="(matricula, index) in items"
                  :key="matricula.id"
                  :class="
                    $constants.situacoesMatriculaCondition[
                      removerEspaco(matricula.situacao ? matricula.situacao : '')
                    ]
                      ? 'red lighten-4'
                      : null
                  "
                >
                  <td width="20">{{ index + 1 }}</td>
                  <td class="font-weight-medium text-left">
                    <div>
                      <span>
                        {{
                          matricula.aluno
                            ? matricula.aluno.nomecompleto
                            : `[ALUNO POSSIVELMENTE DELETADO] MATRICULA: ${matricula.id}`
                        }}</span
                      >
                      <v-tooltip
                        v-if="
                          $constants.situacoesMatriculaCondition[
                            removerEspaco(matricula.situacao ?? '')
                          ] === true
                        "
                        top
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            id="gestoesDeAtendimentosCAEE.infoSituacaoMatriculaBtn"
                            x-small
                            class="ml-2"
                            color="gray lighten-2"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon color="gray lighten-1" small>fa fa-info</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ matricula.situacao }}</span>
                      </v-tooltip>
                    </div>
                    <div>
                      <small>
                        {{ matricula.aluno ? matricula.aluno.codigo_inep : "- - -" }} /
                        {{ matricula.aluno ? matricula.aluno.codigo : "- - -" }}
                      </small>
                    </div>
                  </td>
                  <td>
                    <div class="text-center">
                      <v-menu :close-on-content-click="false" :nudge-width="100" offset-x>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            id="gestoesDeAtendimentosCAEE.acoesBtn"
                            small
                            color="primary"
                            dark
                            v-bind="attrs"
                            v-on="on"
                            v-if="
                              !$constants.situacoesMatriculaCondition[
                                removerEspaco(matricula.situacao ? matricula.situacao : '')
                              ]
                            "
                          >
                            AÇÕES
                          </v-btn>
                        </template>

                        <v-card class="mx-auto" max-width="500">
                          <v-list>
                            <v-list-item-group color="primary">
                              <v-list-item
                                id="gestoesDeAtendimentosCAEE.criarAtendimentoIndividualBtn"
                                v-if="
                                  $can([
                                    'educacaoInclusiva.lancar',
                                    'educacaoInclusiva.syncAll',
                                    'educacaoInclusiva.*',
                                  ])
                                "
                                :to="{
                                  name: 'educacaoInclusiva.fichaDiarioAtendimento',
                                  params: {
                                    matricula_id: matricula.id,
                                    gestaoDeAulasId: gestao_id,
                                  },
                                }"
                              >
                                <v-list-item-icon>
                                  <v-icon lg>mdi mdi-list-status</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                  <v-list-item-title
                                    >Criar Atendimento Individual</v-list-item-title
                                  >
                                </v-list-item-content>
                              </v-list-item>
                              <v-list-item
                                id="gestoesDeAtendimentosCAEE.gerarAtendimentoIndividualBtn"
                                v-if="$can(['relatorios.relatorioCAeeIndividual', 'relatorios.*'])"
                                @click="() => RelatorioDiarioAtendimento(matricula.id, gestao_id)"
                              >
                                <v-list-item-icon>
                                  <v-icon lg>mdi mdi-account-arrow-down-outline</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    Gerar Atendimento Individual
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                              <!--                               
                              <v-list-item
                                :to="{
                                  name: 'educacaoInclusiva.planejamentoMensalAEE',
                                  params: {
                                    matricula_id: matricula.id,
                                    gestaoDeAulasId: gestao_id,
                                  },
                                }"
                              >
                                <v-list-item-icon>
                                  <v-icon lg>mdi-calendar-month-outline</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                  <v-list-item-title>Planejamento Mensal</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>

                              <v-list-item @click="() => openModalMesPlanejamento(matricula.id)">
                                <v-list-item-icon>
                                  <v-icon lg>mdi-calendar-arrow-down</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                  <v-list-item-title
                                    >Gerar Planejamento Mensal</v-list-item-title
                                  >
                                </v-list-item-content>
                              </v-list-item> -->

                              <v-list-item
                                id="gestoesDeAtendimentosCAEE.registrarPlanoIntervencaoBtn"
                                v-if="podeGerenciarPDI"
                                :to="{
                                  name: 'educacaoInclusiva.planoCAEE',
                                  params: {
                                    matricula_id: matricula.id,
                                    gestaoDeAulasId: gestao_id,
                                  },
                                }"
                              >
                                <v-list-item-icon>
                                  <v-icon lg>mdi-clipboard-account-outline</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                  <v-list-item-title
                                    >Registrar Plano de Intervenção
                                    Psicopedagógico</v-list-item-title
                                  >
                                </v-list-item-content>
                              </v-list-item>

                              <v-list-item
                                id="gestoesDeAtendimentosCAEE.gerarPlanoIntervencaoBtn"
                                v-if="podeGerenciarPDI"
                                @click="() => openModalPDI(matricula.id, gestao_id)"
                              >
                                <v-list-item-icon>
                                  <v-icon lg>mdi-clipboard-arrow-down-outline</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                  <v-list-item-title
                                    >Gerar Plano de Intervenção Psicopedagógico</v-list-item-title
                                  >
                                </v-list-item-content>
                              </v-list-item>

                              <v-list-item
                                id="gestoesDeAtendimentosCAEE.criarPaeeBtn"
                                v-if="
                                  $can([
                                    'educacaoInclusiva.lancar',
                                    'educacaoInclusiva.syncAll',
                                    'educacaoInclusiva.*',
                                  ])
                                "
                                :to="{
                                  name: 'educacaoInclusiva.paee',
                                  params: {
                                    matricula_id: matricula.id,
                                    gestaoDeAulasId: gestao_id,
                                  },
                                }"
                              >
                                <v-list-item-icon>
                                  <v-icon lg>mdi-clipboard-text-outline</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                  <v-list-item-title>Criar PAEE</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>

                              <v-list-item
                                id="gestoesDeAtendimentosCAEE.gerarPaeeBtn"
                                v-if="$can(['relatorios.relatorioCAeeIndividual', 'relatorios.*'])"
                                @click="() => openModalPAEE(matricula.id, gestao_id)"
                              >
                                <v-list-item-icon>
                                  <v-icon lg>mdi-clipboard-arrow-down-outline</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                  <v-list-item-title>Gerar PAEE</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list-item-group>
                          </v-list>
                        </v-card>
                      </v-menu>
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-col>
      </template>
    </v-card>

    <e-select-mes-modal
      id="gestoesDeAtendimentosCAEE.selecionarMesModal"
      :dialog="dialogMes"
      confirmText="Gerar relatório"
      cancelText="Fechar"
      @changeAction="baixarPlanejamentoMensalAEE"
      @dialogChange="dialogMes = $event"
    ></e-select-mes-modal>

    <e-select-bimestre-modal
      id="gestoesDeAtendimentosCAEE.selecionarBimestrePdiModal"
      :dialog="dialogBimestrePDI"
      confirmText="Gerar relatório"
      cancelText="Fechar"
      @changeAction="baixarPlanoPDI"
      @dialogChange="dialogBimestrePDI = $event"
    ></e-select-bimestre-modal>

    <e-select-bimestre-modal
      id="gestoesDeAtendimentosCAEE.selecionarBimestrePaeeModal"
      :dialog="dialogBimestrePAEE"
      confirmText="Gerar relatório"
      cancelText="Fechar"
      @changeAction="baixarPAEE"
      @dialogChange="dialogBimestrePAEE = $event"
    ></e-select-bimestre-modal>
  </main-template>
</template>

<script>
export default {
  computed: {
    matriculasAtivas() {
      return this.matriculas.filter(
        (m) =>
          (m.situacao && m.situacao.toLowerCase().trim() === "cursando") ||
          m.situacao.toLowerCase().trim() === "recebida" ||
          m.situacao.toLowerCase().trim() === "aprovado" ||
          m.situacao.toLowerCase().trim() === "reprovado"
      );
    },
    anoAntesDe2026() {
      return this.turma.ano.descricao < 2026;
    },
    podeGerenciarPDI() {
      const user = this.$store.getters["Auth/user"];
      if (!user) return false;
      const rolesPermitidas = [
        "psicopedagogo",
        "coordenador-caee",
        "gerente-administrativo",
        "diretor-caee",
        "super-admin",
        "admin",
      ];
      return user.roles.some((role) => rolesPermitidas.includes(role.name.toLowerCase()));
    },
  },
  data() {
    return {
      turma: null,
      profissional: null,
      gestao_id: null,
      matriculas: [],
      tabs: [],
      tab_atual: 0,
      table: {
        headers: [
          { text: "#", value: "id" },
          { text: "Aluno", value: "nomeFranquia" },
          { text: "", value: "actions", sortable: false, width: "200px" },
        ],
      },
      carregandoGestoesDeAulas: false,
      dialog: false,
      dialogSemestre: false,
      dialogMes: false,
      dialogBimestrePDI: false,
      dialogBimestrePAEE: false,
      matricula_id_planejamento: null,
      matricula_id_pdi: null,
      gestao_id_pdi: null,
      matricula_id_paee: null,
      gestao_id_paee: null,
    };
  },
  async mounted() {
    await this.loadBasicData();
  },
  methods: {
    openModalSelectMonths(matricula_id, gestao_id) {
      this.matricula_id = matricula_id;
      this.gestao_id = gestao_id;
      this.dialog = !this.dialog;
    },
    openModalMesPlanejamento(matricula_id) {
      this.matricula_id_planejamento = matricula_id;
      this.mesSelecionadoPlanejamento = null;
      this.dialogMes = true;
    },
    openModalPDI(matricula_id, gestao_id) {
      this.matricula_id_pdi = matricula_id;
      this.gestao_id_pdi = gestao_id;
      this.dialogBimestrePDI = true;
    },
    openModalPAEE(matricula_id, gestao_id) {
      this.matricula_id_paee = matricula_id;
      this.gestao_id_paee = gestao_id;
      this.dialogBimestrePAEE = true;
    },
    async baixarPlanejamentoMensalAEE(mes_id) {
      this.$loaderService.open("Carregando dados...");
      try {
        await this.$services.relatoriosService.relatorioPlanejamentoMensalCAEE(
          parseInt(this.matricula_id_planejamento, 10),
          parseInt(this.gestao_id, 10),
          mes_id
        );
        this.dialogMes = false;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async baixarPlanoPDI(bimestre) {
      this.$loaderService.open("Carregando dados...");
      try {
        await this.$services.relatoriosService.relatorioPlanoCAEE(
          parseInt(this.matricula_id_pdi, 10),
          parseInt(this.gestao_id_pdi, 10),
          bimestre
        );
        this.dialogBimestrePDI = false;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async baixarPAEE(bimestre) {
      this.$loaderService.open("Carregando dados...");
      try {
        await this.$services.relatoriosService.relatorioPAEE(
          parseInt(this.matricula_id_paee, 10),
          parseInt(this.gestao_id_paee, 10),
          bimestre
        );
        this.dialogBimestrePAEE = false;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async gerarRelatorio() {
      this.$loaderService.open("Carregando dados...");
      await this.$services.relatoriosService.listarTurma(parseInt(this.$route.params.turmaId, 10));
      this.$loaderService.close();
    },
    async RelatorioDiarioAtendimento(matricula_id, gestao_id) {
      this.$loaderService.open("Carregando dados...");
      await this.$services.relatoriosService.relatorioDiarioAtendimento(
        parseInt(matricula_id, 10),
        parseInt(gestao_id, 10)
      );
      this.$loaderService.close();
    },
    async loadBasicData() {
      this.$loaderService.open("Carregando dados...");
      try {
        const payload = await this.$services.gestoesDeAtendimentosCAEEService.visualizarTurma(
          parseInt(this.$route.params.gestaoDeAulasId, 10)
        );
        this.gestao_id = payload.id;
        this.turma = payload.turma;
        this.profissional = payload.profissional;
        this.matriculas = payload.turma.matriculas || [];
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    gerarRelatorioAnual(semestre) {
      this.$loaderService.open("Carregando dados...");
      this.$services.relatoriosService.relatorioEspecialDesenvolvimentoAnual(
        this.matricula_id,
        this.gestao_id,
        semestre
      );
      this.$loaderService.close();
    },
    async relatorioEspecialDesenvolvimentoBimestral(bimestre) {
      this.$loaderService.open("Carregando dados...");
      try {
        await this.$services.relatoriosService.relatorioEspecialDesenvolvimentoBimestral(
          this.matricula_id,
          this.gestao_id,
          bimestre
        );
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    removerEspaco(string) {
      return string.replace(" ", "_").replace(" ", "_").replace(" ", "_");
    },
  },
};
</script>

<style scoped></style>
